import { useSelector } from 'react-redux';
import { getIsDownsized } from '../../selectors/settings';

export const useConnect = () => ({
  isDownsized: useSelector(getIsDownsized),
});
